<!--FastBI产品-->
<template>
  <div class="upgradeDialog">
    <el-dialog
      :before-close="restForm"
      :title="'升级'"
      :visible.sync="visible"
      :close-on-click-modal="false"
      width="560px"
    >
      <el-form :model="upgradeData" ref="form" :rules="formRules">
        <el-form-item :label-width="formLabelWidth" label="授权IP/域名" prop="name">
          <el-input v-model="upgradeData['domain']" disabled></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="当前版本" prop="name">
          <el-input v-model="upgradeData['showVersion']" disabled></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="升级版本至" prop="edition">
          <!-- <el-input value="暂无可升级版本" disabled v-if="!toVersionOption().lnegth"></el-input> -->
          <!-- v-else -->
          <el-select v-model="upgradeData['toVersion']" filterable placeholder="请选择">
            <!-- <el-option v-for="item in toVersionOption" :key="item.name" :label="item.name" :value="item.value"> -->
            <el-option v-for="item in versionOptionData" :key="item.name" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form', (visible = false))">取 消</el-button>
        <el-button @click="upgradeSubmit" type="primary">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getXZEditions } from '@/api/auth';
import { getVersionOption, version } from './utils';
import { MessageBox, Message } from 'element-ui';
import { productUpdate } from '@/api/xz_product';
export default {
  data() {
    return {
      visible: false,
      formLabelWidth: '110px',
      formRules: {
        edition: [
          {
            required: true,
            message: '请输入升级的版本',
            trigger: 'blur',
          },
        ],
      },
      upgradeData: {
        domain: '',
        code: '',
        version: '',
        toVersion: '',
      },
      optionalVersion: {},
      versionOptionData: [],
    };
  },
  mounted() {},
  methods: {
    restForm(done) {
      this.cancel();
      done();
    },
    show() {
      this.visible = true;
    },
    setFormData({ data, XZEditions }) {
      console.log(data, XZEditions, 'datadatadata');
      const { grade, code, id, domain } = data;
      const parseVersionText = (grade) => {
        return version[grade];
      };
      this.upgradeData = {
        ...this.upgradeData,
        version: grade,
        showVersion: parseVersionText(grade),
        code: code,
        domain,
        id,
      };
      this.parseVersion(XZEditions);
    },
    createToversionOption() {
      this.upgradeData;
    },
    cancel(formName, close) {
      this.upgradeData = {
        code: '',
        version: '',
        toVersion: '',
      };
    },
    parseVersion(data) {
      const result = {};
      data.forEach((item) => {
        if (result[item.edition]) {
          result[item.edition].push(item.grade);
        } else {
          result[item.edition] = [item.grade];
        }
      });
      this.optionalVersion = result;
      this.versionOptionData = this.toVersionOption();
    },
    async upgradeSubmit() {
      const { id, toVersion } = this.upgradeData;
      const data = { grade: toVersion };
      try {
        const res = await productUpdate({ id, data });
        const text = getVersionOption().find((i) => i.value === toVersion);
        if (res.code) {
          Message({
            message: `成功升级为${text.name}`,
            type: 'success',
            duration: 3 * 1000,
          });
          this.visible = false;
          /* 更新表格数据 */
          this.$parent.search();
        }
      } catch (error) {
        console.warn(error);
      }
    },
    toVersionOption() {
      if (!this.optionalVersion[this.upgradeData.version]) {
        return [];
      }
      const data = this.optionalVersion[this.upgradeData.version].filter((i) => i > this.upgradeData.version);
      return getVersionOption().filter((i) => data.includes(i.value));
    },
  },
  computed: {
    /* 没有判断权限
    toVersionOption() {
      return getVersionOption().filter((i) => i.value > this.upgradeData.version);
    },
    */
    /*
    toVersionOption() {
      console.log(this.optionalVersion[this.upgradeData.version]);
      const data = this.optionalVersion[this.upgradeData.version].filter((i) => i > this.upgradeData.version);
      return getVersionOption().filter((i) => data.includes(i.value));
    },
    */
  },
};
</script>



// WEBPACK FOOTER //
// src/components/xzReport/upgradeDialog.vue